// extracted by mini-css-extract-plugin
export var accent = "_87-4";
export var add = "_87-j";
export var addIcon = "_87-k";
export var deleteIcon = "_87-i";
export var disabled = "_87-9";
export var ellipsis = "_87-f";
export var error = "_87-3";
export var form = "_87-5";
export var hideFocus = "_87-2";
export var icon = "_87-7";
export var input = "_87-e";
export var listItem = "_87-h";
export var mediumHeight = "_87-b";
export var noBorder = "_87-8";
export var noRadius = "_87-1";
export var shortHeight = "_87-a";
export var tallHeight = "_87-c";
export var textInput = "_87-0";
export var vertical = "_87-g";
export var veryTallHeight = "_87-d";
export var widget = "_87-6";